/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface NahledyudajuPppChybaDto {
	kod?: 'OBECNA_CHYBA' | 'CHYBA_VSTUPU' | 'NENALEZENO';
	popis?: string;
}

export interface NahledyudajuPppChybyDto {
	chyby?: NahledyudajuPppChybaDto[];
}

export interface NahledyudajuPppOdpovedSeznamDto {
	/** @format int64 */
	pocet?: number;
}

export type NahledyudajuPppPppSeznamResponseDto =
	NahledyudajuPppOdpovedSeznamDto & {
		seznam?: NahledyudajuPppPppZaznamShrnutiDto[];
	};

export interface NahledyudajuPppPppZaznamShrnutiDto {
	pppId?: string;
	nazev?: string;
	stav?: NahledyudajuPppPppStavEnum;
	/** @format date */
	datumPodani?: string;
	subjekt?: NahledyudajuPppPppSubjektShrnutiDto;
	ovm?: NahledyudajuPppOvmShrnutiDto;
}

export interface NahledyudajuPppPppSubjektShrnutiDto {
	typ?: 'FO' | 'PFO_PO' | 'REZA_FO' | 'REZA_PFO_PO';
	nazev?: string;
	ico?: string;
	identifikator?: string;
}

export interface NahledyudajuPppOvmShrnutiDto {
	kod?: string;
	nazev?: string;
}

export enum NahledyudajuPppPppStavEnum {
	PRIJATO = 'PRIJATO',
	SCHVALENO = 'SCHVALENO',
	ODESLANO_K_DOPRACOVANI = 'ODESLANO_K_DOPRACOVANI',
	ODESLANO_SPRAVCI = 'ODESLANO_SPRAVCI',
	ZAMITNUTO = 'ZAMITNUTO',
	UKONCENO = 'UKONCENO',
}

export interface NahledyudajuPppPppDetailDto {
	zakladniUdaje?: NahledyudajuPppPppZakladniUdajeDto;
	zadatel?: NahledyudajuPppPppOsobaDto;
	zastupovanaOsoba?: NahledyudajuPppPppOsobaDto;
	prijemce?: NahledyudajuPppPppPrijemceDto;
	zadost?: NahledyudajuPppPppZadostDetailyDto;
	reklamace?: NahledyudajuPppPppReklamaceDto[];
}

export interface NahledyudajuPppPppZakladniUdajeDto {
	pppId?: string;
	idZadosti?: string;
	nazev?: string;
	stav?: NahledyudajuPppPppStavEnum;
	/** @format date */
	datumPodani?: string;
	/** @format date-time */
	datumPosledniZmeny?: string;
	duvodZamitnuti?: string;
}

export interface NahledyudajuPppPppOsobaDto {
	typ?: 'FO' | 'PFO_PO' | 'REZA_FO' | 'REZA_PFO_PO';
	jmeno?: string;
	prijmeni?: string;
	/** @format date */
	datumNarozeni?: string;
	nazev?: string;
	ico?: string;
	adresa?: NahledyudajuPppAdresaDto;
	identifikator?: string;
}

export interface NahledyudajuPppAdresaDto {
	ulice?: string;
	cisloPopisne?: string;
	cisloOrijentacni?: string;
	cisloEvidencni?: string;
	obec?: string;
	castObce?: string;
	psc?: string;
}

export interface NahledyudajuPppPppPrijemceDto {
	ovm?: NahledyudajuPppOvmShrnutiDto;
	utvar?: string;
	utvarSpecifikace?: string;
}

export interface NahledyudajuPppPppZadostDetailyDto {
	typPppKod?: string;
	typPppNazev?: string;
	dokumentCislo?: string;
	/** @format date */
	datumVydani?: string;
	/** @format date */
	datumPlatnostiOd?: string;
	/** @format date */
	datumPlatnostiDo?: string;
	prilohy?: NahledyudajuPppPppPrilohaDto[];
}

export interface NahledyudajuPppPppPrilohaDto {
	nazevSouboru?: string;
	/** @format uuid */
	souborGuid?: string;
}

export interface NahledyudajuPppPppReklamaceDto {
	stav?:
		| 'PRIJATA'
		| 'ZAMITNUTA'
		| 'VYRESENA'
		| 'SCHVALENA'
		| 'ROZPRACOVANA'
		| 'CEKA_NA_RESENI';
	/** @format date */
	datum?: string;
	resitel?: string;
	komentarOvm?: string;
}

export interface NahledyudajuPppPppTypyResponseDto {
	typy?: NahledyudajuPppPppTypDto[];
}

export interface NahledyudajuPppPppTypDto {
	kod?: string;
	nazev?: string;
}

export type NahledyudajuPppOvmSeznamResponseDto =
	NahledyudajuPppOdpovedSeznamDto & {
		seznam?: NahledyudajuPppOvmDetailDto[];
	};

export interface NahledyudajuPppOvmDetailDto {
	kod?: string;
	nazev?: string;
	adresa?: NahledyudajuPppAdresaDto;
	zanikly?: boolean;
}

export interface NahledyudajuPppReklamaceTypyResponseDto {
	typy?: NahledyudajuPppReklamaceTypDto[];
}

export interface NahledyudajuPppReklamaceTypDto {
	kod?: string;
	nazev?: string;
}

export interface NahledyudajuPppVypisSeznamPppParams {
	/** Volí záložku Aktuálně platné vs Již neplatné. */
	typSeznamu: 'AKTUALNI' | 'HISTORIE';
	/** Filtruje podle stavu evidence. */
	stav?:
		| 'VSE'
		| 'PRIJATO'
		| 'SCHVALENO'
		| 'ODESLANO_K_DOPRACOVANI'
		| 'ODESLANO_SPRAVCI'
		| 'ZAMITNUTO'
		| 'UKONCENO';
	/** Fulltextové hledání v názvu subjektu, OVM nebo ID žádosti. */
	text?: string;
	/**
	 * Spodní hranice filtru dle data podání/ukončení.
	 * @format date
	 */
	datumOd?: string;
	/**
	 * Horní hranice filtru dle data podání/ukončení.
	 * @format date
	 */
	datumDo?: string;
	/**
	 * Index první položky ve stránce.
	 * @default 0
	 */
	start?: number;
	/**
	 * Počet položek na stránce.
	 * @default 20
	 */
	pocet?: number;
}

export interface NahledyudajuPppVypisTypyPppParams {
	/** Filtrovat podle části názvu. */
	text?: string;
}

export interface NahledyudajuPppVypisOvmProTypPppParams {
	text?: string;
	/** @default 0 */
	start?: number;
	/** @default 50 */
	pocet?: number;
	typPppKod: string;
}
